<div class="card">

  <div class="card-header">
    {{'MENU_NAVBAR_OUTGOING_SMS' | translate}}

    <div class="card-actions">
    </div><!-- /.card-actions -->

  </div>

  <div class="card-body">
    <table class="table table-striped table-bordered">
      <thead>
      <tr>
        <th class="table-sorter-header">
          <app-table-field-sorter [orderField]="TaskRecordOutgoingSmsSearch.OrderFunctions.ID"
                                  [orderType]="queryModel.getOrderType(TaskRecordOutgoingSmsSearch.OrderFunctions.ID)"
                                  (orderChange)="orderBy($event)"
                                  [text]="'COMMON_TABLE_HEADER_ID' | translate"></app-table-field-sorter>
        </th>
        <th class="table-sorter-header hidden-md-down">
          <app-table-field-sorter [orderField]="TaskRecordOutgoingSmsSearch.OrderFunctions.MESSAGE_ID"
                                  [orderType]="queryModel.getOrderType(TaskRecordOutgoingSmsSearch.OrderFunctions.MESSAGE_ID)"
                                  (orderChange)="orderBy($event)"
                                  [text]="'OUTGOING_SMS_MESSAGE_ID' | translate"></app-table-field-sorter>
        </th>
        <th class="table-sorter-header hidden-md-down">
          <app-table-field-sorter [orderField]="TaskRecordOutgoingSmsSearch.OrderFunctions.DELIVERY_TIME"
                                  [orderType]="queryModel.getOrderType(TaskRecordOutgoingSmsSearch.OrderFunctions.DELIVERY_TIME)"
                                  (orderChange)="orderBy($event)"
                                  [text]="'OUTGOING_SMS_DELIVERY_TIME' | translate"></app-table-field-sorter>
        </th>
        <th class="table-sorter-header">
          <app-table-sorter-no-op
            [text]="'COMMON_CONTACT_PERSON_PHONE_NUMBER' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header">
          <app-table-sorter-no-op
            [text]="'TASK_RECORD_OUTGOING_SMS_CONTENT' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header">
          <app-table-sorter-no-op
            [text]="'TASK_RECORD_OUTGOING_SMS_STATE' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header hidden-md-down">
          <app-table-sorter-no-op
            [text]="'TASK_RECORD_OUTGOING_SMS_SEND_MODE' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header w-table-options-menu">
          <app-table-sorter-no-op></app-table-sorter-no-op>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let sms of smsList | paginate: {
                                                      itemsPerPage: queryModel.itemsPerPage,
                                                      currentPage: queryModel.currentPage,
                                                      totalItems: queryModel.currentNumberOfItems }">
        <td class="responsive-table-column">{{sms.id}}</td>
        <td class="responsive-table-column hidden-md-down">{{sms.messageId}}</td>
        <td class="responsive-table-column hidden-md-down">{{sms.deliveryTime.toUtcIsoString() | date: 'short'}}</td>
        <td class="responsive-table-column">{{sms.recipient.toIso()}}</td>
        <td class="responsive-table-column long text-break">{{sms.content}}</td>
        <td class="responsive-table-column">{{getStateKey(sms.state!) | translate}}
          <ng-container *ngIf="sms.bipState">
            <p class="table-text-subtitle mb-0">{{sms.bipStateMessage}}</p>
            <p class="table-text-subtitle mb-0">{{sms.bipStateTimestamp.toUtcIsoString() | date:'short'}}</p>
          </ng-container>
          <ng-container *ngIf="!sms.bipState">
            <p class="table-text-subtitle mb-0">{{sms.statusInfo}}</p>
            <p class="table-text-subtitle mb-0">{{sms.statusCode}}</p>
          </ng-container>
        </td>
        <td class="responsive-table-column hidden-md-down">{{getSendModeKey(sms.sendMode!) | translate}}
          <p class="table-text-subtitle mb-0">{{getIntegrationType(sms.integrationType!) | translate}}</p>
        </td>
        <td class="responsive-table-column w-table-options-menu">
          <a class="icons-table-group cursor-pointer"
             *ngIf="rightModel.outgoingSmsSend.hasRight()"
             (click)="resendSms(sms)">
            <i class="icomoon icons-table-item icomoon-message-send"
               title="{{'COMMON_BUTTON_SEND' | translate}}"></i>
          </a>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <th class="table-sorter-header">
          <app-table-field-sorter [orderField]="TaskRecordOutgoingSmsSearch.OrderFunctions.ID"
                                  [orderType]="queryModel.getOrderType(TaskRecordOutgoingSmsSearch.OrderFunctions.ID)"
                                  (orderChange)="orderBy($event)"
                                  [text]="'COMMON_TABLE_HEADER_ID' | translate"></app-table-field-sorter>
        </th>
        <th class="table-sorter-header hidden-md-down">
          <app-table-field-sorter [orderField]="TaskRecordOutgoingSmsSearch.OrderFunctions.MESSAGE_ID"
                                  [orderType]="queryModel.getOrderType(TaskRecordOutgoingSmsSearch.OrderFunctions.MESSAGE_ID)"
                                  (orderChange)="orderBy($event)"
                                  [text]="'OUTGOING_SMS_MESSAGE_ID' | translate"></app-table-field-sorter>
        </th>
        <th class="table-sorter-header hidden-md-down">
          <app-table-field-sorter [orderField]="TaskRecordOutgoingSmsSearch.OrderFunctions.DELIVERY_TIME"
                                  [orderType]="queryModel.getOrderType(TaskRecordOutgoingSmsSearch.OrderFunctions.DELIVERY_TIME)"
                                  (orderChange)="orderBy($event)"
                                  [text]="'OUTGOING_SMS_DELIVERY_TIME' | translate"></app-table-field-sorter>
        </th>
        <th class="table-sorter-header">
          <app-table-sorter-no-op
            [text]="'COMMON_CONTACT_PERSON_PHONE_NUMBER' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header">
          <app-table-sorter-no-op
            [text]="'TASK_RECORD_OUTGOING_SMS_CONTENT' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header">
          <app-table-sorter-no-op
            [text]="'TASK_RECORD_OUTGOING_SMS_STATE' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header">
          <app-table-sorter-no-op
            [text]="'TASK_RECORD_OUTGOING_SMS_SEND_MODE' | translate"></app-table-sorter-no-op>
        </th>
        <th class="table-sorter-header w-table-options-menu">
          <app-table-sorter-no-op></app-table-sorter-no-op>
        </th>
      </tr>
      </tfoot>
    </table>
    <app-table-paging
      [currentNumberOfItems]="queryModel.currentNumberOfItems"
      [totalNumberOfItems]="queryModel.totalNumberOfItems"
      [itemsPerPage]="queryModel.itemsPerPage"
      (pageChange)="pageChanged($event)"
      (itemsPerPageChange)="itemsPerPageChanged($event)">
    </app-table-paging>
  </div>
</div>
